window.printessGlobalConfig = window.printessGlobalConfig || {};

(() => {
  // Dedup: falls Printess mehrfach feuert (onSave + onSaveAsync)
  let lastToken = null;
  let lastTs = 0;

  const DEDUPE_WINDOW_MS = 1500;

  const buildShareUrl = (saveToken) => {
    // Stabil: nicht die komplette aktuelle URL übernehmen
    const url = new URL(window.location.origin + window.location.pathname);

    const current = new URL(window.location.href);

    // Optional: variant beibehalten (macht bei PDP Sinn)
    const variant = current.searchParams.get('variant');
    if (variant) url.searchParams.set('variant', variant);

    // SaveToken setzen
    url.searchParams.set('savetoken', saveToken);

    return url.toString();
  };

  const emitPrintessSaved = (saveToken, thumbnailUrl, params) => {
    if (!saveToken) return;

    // Dedup
    const now = Date.now();
    if (saveToken === lastToken && (now - lastTs) < DEDUPE_WINDOW_MS) return;
    lastToken = saveToken;
    lastTs = now;

    const shareUrl = buildShareUrl(saveToken);

    document.dispatchEvent(
      new CustomEvent('printess:saved', {
        detail: { saveToken, thumbnailUrl, params: params || null, shareUrl }
      })
    );
  };

  // Printess kann entweder sync oder async callback nutzen – wir unterstützen beides
  window.printessGlobalConfig.onSave = (saveToken, thumbnailUrl, params) =>
    emitPrintessSaved(saveToken, thumbnailUrl, params);

  window.printessGlobalConfig.onSaveAsync = async (saveToken, thumbnailUrl, params) =>
    emitPrintessSaved(saveToken, thumbnailUrl, params);
})();